import React from 'react';
import { Modal, TouchableWithoutFeedback, View, StyleProp, ViewStyle } from 'react-native';

type ExpenseEditorModalProps = {
  visible: boolean;
  onClose: () => void;
  overlayStyle?: StyleProp<ViewStyle>;
  children: React.ReactNode;
};

const ExpenseEditorModal = ({ visible, onClose, overlayStyle, children }: ExpenseEditorModalProps) => {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <TouchableWithoutFeedback onPress={onClose}>
        <View style={overlayStyle}>
          <TouchableWithoutFeedback>{children}</TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

export default ExpenseEditorModal;
